import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types/api';
import { IReportApiListResponse } from '@/types/report';

export const reportList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IReportApiListResponse>> => {
    return axios.get('/api/balance/list', { ...config, params });
};
